import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IParams } from '../model/http';
import { environment } from '../../environments/environment';
import { initItemsGroParams } from './crm.service';

export const initItemsRingParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};


@Injectable({
  providedIn: 'root'
})
export class RingostatService {

  private readonly itemsSubject$ = new BehaviorSubject<any>({});
  public readonly items$ = this.itemsSubject$.asObservable();
  public readonly isLoader$ = new BehaviorSubject<boolean>(false);
  public queryRingostatParams = { ...initItemsRingParams };



  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
  ) {
  }

  loadListItems() {
    this.isLoader$.next(true);
    return this.getItems(this.queryRingostatParams)
      .pipe(tap((v) => {
        this.itemsSubject$.next(v);
        this.isLoader$.next(false);
      }));
  }

  public setRingostatParams(params: IParams) {
    const {
      sort,
      order,
      search,
      take,
      page
    } = params;

    this.queryRingostatParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryRingostatParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryRingostatParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryRingostatParams.search,
      take: take || this.queryRingostatParams.take,
      page: page || this.queryRingostatParams.page,
    };

    return this.loadListItems();
  }

  private getItems(params: any) {
    return this.http.get<any>(environment.baseURL + '/ringostat/history', { params })
      .pipe(map(v => v.data));
  }

  getKeys() {
    return this.http.get<any>(environment.baseURL + '/ringostat/keys')
      .pipe(map(v => v.data));
  }

  addApiRingostat(payload: any ) {
    const url = environment.baseURL + '/ringostat/integrate';
    return this.http.post<any>(url, payload);
  }

  putApiRingostat(payload: any, id: string ) {
    const url = environment.baseURL + `/ringostat/${id}`;
    return this.http.put<any>(url, payload);
  }

  connect(payload: any, id: string ) {
    const url = environment.baseURL + `/v2/ringostat/${id}`;
    return this.http.post<any>(url, payload);
  }

  deleteApiRingostat(id: any ) {
    return this.http.delete<any>(environment.baseURL + `/ringostat/${id}`)
      .pipe(map(v => v.data));

  }
}
